import { Component, OnInit } from '@angular/core';
import { ProductService } from 'app/services/product.service';
import { Product, ProductImagesList, ProductName, ProductNames} from 'app/models/products.model';
import { MockProduct2, MockProduct3 } from 'app/models/data/mock/products';
import { formatCurrency} from 'app/utilities/format-utils';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { SharedDataService } from 'app/services/sharedData.service';
import { UserService } from 'app/users/user.service';
import { CustomerService } from 'app/services/customer.service';
import { Subscription } from 'app/models/customer.model';
import { environment } from 'environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { finalize } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { PageConfig } from 'config/page.config';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})


export class LandingPageComponent implements OnInit {
 


  products: Product[] = [];
  loaded: boolean = false; 
  subscriptions: Subscription[] = [];
  isSmallView: boolean = false;
  isTabletView: boolean = false;
  product2: any = {};
  product3: any = {};
  contactUsUrl: string = environment.contactUs;
  isAdmin: boolean = false;
  customerNumber: string = "";
  
  constructor(private productService: ProductService, 
    private alertService: AlertsService, 
    private sharedDataService: SharedDataService,
    private customerService: CustomerService,
    private userService: UserService,
    private authService: AuthService,
    private dialog: MatDialog,
    private responsive: BreakpointObserver,
    private router: Router 
  ) { }

  ngOnInit() {
    this.determineViewMode();
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'landing'
    }
    if(typeof this.userService.profile !== "undefined") {
      token['customerNumber'] = this.userService.profile.customerNumber;
      this.customerNumber = this.userService.profile.customerNumber;
    } else {
      token['customerNumber'] = '';
      this.isAdmin = false;
    }
    this.authService.getToken(token)
     .pipe(
      finalize(() => {
        if(typeof this.userService.profile !== "undefined") {
          this.sharedDataService.getSubscriptions.subscribe(data => {
            if(data === null) {
              this.customerService.fetchSubscriptions(this.userService.profile.customerNumber, ProductNames).subscribe({
                next: (res) => {
                  if (res.Errors.length > 0 && res.Data === null) {       
                    this.loadProducts();         
                  } else {
                    const subscriptions = res.Data.filter( (d) => d.Status.Name === "Active");
                    if (subscriptions.length > 1) this.router.navigate([PageConfig.paths.invalidPermissions, {error: 'Multiple active subscriptions.'}]);
                    for (const sub of subscriptions) {
                      if (this.customerNumber.length > 0)
                      {
                        const admins =  sub.Participants.filter( (p) => p.CustomerNumber === this.customerNumber && p.AccessType.startsWith("Admin"))
                        this.isAdmin = admins.length > 0;
                      }  
                      let adminRec = sub.Participants.find((p) => p.AccessType.startsWith("Admin"));
                      const itemNumber = sub.Components[0].ItemNumber;
                      const subscription: Subscription = {
                          productName: ProductName[itemNumber],//sub.Components[0].ProductName,
                          productType: "Online",
                          productNumber: itemNumber,
                          status: sub.Status.Name,
                          term: this.parseTerm(sub.ServicePeriod.Code),
                          userCount: sub.Components[0].QuantityOrdered,
                          startDate: new Date(sub.TermStarts).toLocaleDateString(),
                          expireDate: new Date(sub.AgreementExpires).toLocaleDateString(),
                          totalAmount: formatCurrency(sub.Components[0].AccessPoint.Amounts.TotalAmount),
                          agreementId: sub.AgreementId,
                          adminName: adminRec?.FullName ? adminRec?.FullName : '',
                          adminEmail: adminRec?.Email ? adminRec?.Email : '',
                          servicePeriodCode: sub.ServicePeriod.Code
                      }
                      this.subscriptions.push(subscription);  
                    } 
                    this.sharedDataService.setSubscriptions(res.Data) 
                  }
                  this.loadProducts();   
                },
                error: (err) => { 
                  console.log(err); 
                  this.loadProducts(); 
                }              
              });     
            } else {
              const subscriptions = data.filter( (d) => d.Status.Name === "Active");
              if (subscriptions.length > 1) this.router.navigate([PageConfig.paths.invalidPermissions, {error: 'Multiple active subscriptions.'}]);
              for (const sub of subscriptions) {
                if (this.customerNumber.length > 0)
                {
                  const admins =  sub.Participants.filter( (p) => p.CustomerNumber === this.customerNumber && p.AccessType.startsWith("Admin"))
                  this.isAdmin = admins.length > 0;
                }  
                let adminRec = sub.Participants.find((p) => p.AccessType.startsWith("Admin"));
                const itemNumber = sub.Components[0].ItemNumber;
                const subscription: Subscription = {
                    productName: ProductName[itemNumber],//sub.Components[0].ProductName,
                    productType: "Online",
                    productNumber: itemNumber,
                    status: sub.Status.Name,
                    term: this.parseTerm(sub.ServicePeriod.Code),
                    userCount: sub.Components[0].QuantityOrdered,
                    startDate: new Date(sub.TermStarts).toLocaleDateString(),
                    expireDate: new Date(sub.AgreementExpires).toLocaleDateString(),
                    totalAmount: formatCurrency(sub.Components[0].AccessPoint.Amounts.TotalAmount),
                    agreementId: sub.AgreementId,
                    adminName: adminRec?.FullName ? adminRec?.FullName : '',
                    adminEmail: adminRec?.Email ? adminRec?.Email : ''
                }
                this.subscriptions.push(subscription);    
              }
              this.loadProducts();               
            }
          });
        } else {
          this.loadProducts();
        }          
      })
    )
     .subscribe();
  }
  

  loadProducts() {
    this.sharedDataService.getProducts.subscribe(data => {
      if (data.length > 0) {        
        this.products = data;   
        this.product2 = MockProduct2;  
        this.product3 = MockProduct3;    
        this.loaded = true;   
      } else {
        this.productService.fetchProducts()
        .subscribe({
          next: (res) => {
            this.products = res.Data.results;
            this.sharedDataService.setProducts(this.products);
            this.loaded = true;
          },
          error: (err) => { 
            console.log(err);
            this.alertService.displayError("Error getting products: " + err.message);
            this.loaded = true;
          }              
        });
      }      
    });
  }

  getProductImage(productCode: string) {
    //return ProductImage.hasOwnProperty(productCode) ? ProductImage[productCode] : "";
    //ProductImagesList
    return ProductImagesList?.find( p => p.prodCode === productCode)?.image;
  }
  getProductPrice(productName: string, tierName: string) {
    const prod = this.products.find( p => p.name === productName);
    if (typeof prod !== "undefined") {
      const tier = prod.tiers.find( t => t.tierName === tierName);
      const price = (typeof tier !== 'undefined' && tier.tierDetails.length >0 ) ? tier?.tierDetails[0].unitPrice : 0;
      return formatCurrency(price);
    } else {
      return "$0.00"
    }
  }

  parseTerm(termValue: string) {
    const term = termValue.substring(2).replace(/0/gi,'');    
    return "Term: " + term + ((term === '1') ? " Year": " Years");
  }
  
  hasSubscription(itemNumber: string) {
    if (this.subscriptions.length > 0) {
      const found = this.subscriptions.filter( (sub) => sub.productNumber === itemNumber);
      return found.length > 0;
    } else {
      return false;
    }
  }

  getSubscription(itemNumber: string) {
    if (this.subscriptions.length > 0) {
      const found = this.subscriptions.filter( (sub) => sub.productNumber === itemNumber);
      return (found.length > 0) ? found[0] : null;
    } else { return null }
  }
  
  renew(itemNumber: string) {
    let sub = this.getSubscription(itemNumber);
    if(sub)
      this.router.navigate([PageConfig.paths.ocm.billing]);
    else {
      this.alertService.displayError("Cannot renew subscription since its not found");
    }

  } 
  
  determineViewMode() {
    this.responsive.observe([Breakpoints.HandsetPortrait, Breakpoints.TabletPortrait])
      .subscribe(result => {
        this.isSmallView = false;
        this.isTabletView = false;
        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.HandsetPortrait])
          this.isSmallView = true;
        else if (breakpoints[Breakpoints.TabletPortrait])
          this.isTabletView = true;
    });
  }

  navigateToProduct() {
    window.open(environment.findACode, '_blank');
  }

  viewProduct(itemNumber: string) {
    if(this.subscriptions && this.subscriptions.length > 0)
      this.router.navigate(['/product', itemNumber]);
  }

  accessProduct() {
    window.open(environment.rbrvs, '_blank');
  }

  getProductName(itemNumber: string) {
    return ProductName[itemNumber];
  }
}
